import * as React from 'react'
import { getStaticSlugsPaths } from '../../../helpers/nextHelpers'
import type { SlugsStaticType } from '../../../helpers/nextHelpers'
import { withRouter } from 'next/router'
import {
  getSlugsByCategoryTypeAsync
} from '../../../models/Category'
import { convertCreatorBySlugToProps } from '../../../models/Creator'
import type { CreatorPropsType } from '../../../models/Creator'
import DiscoverLayout from '@components/Discover/DiscoverLayout'
import { CreatorDetail } from '@components/Creator/CreatorDetail'
function Creator (props: CreatorPropsType): React.ReactNode {
  return (
    <DiscoverLayout background title={`Listen to stories by ${props.title} on Dipsea`} description={`Listen to stories by ${props.title} on Dipsea. ${props.description}`} imageUrl={props.imageUrl}>
      <CreatorDetail {...props} />
    </DiscoverLayout>
  )
}
export default withRouter(Creator as any) as any

type ContextType = {
  params: {
    slug: string
  }
}
export async function getStaticProps (
  context: ContextType
): Promise<{ props: CreatorPropsType }> {
  const props = await convertCreatorBySlugToProps(context.params.slug)
  return { props }
}
export async function getStaticPaths (): Promise<SlugsStaticType> {
  const slugs = await getSlugsByCategoryTypeAsync('creator')
  return getStaticSlugsPaths(slugs)
}
